import React from 'react';
import Wrp from '../../hoc/Wrp/Wrp';
import Modal from "react-bootstrap/Modal";
import Inputs from '../../Components/Inputs/Inputs';
import Icons from "../../Components/Icons/Icons";
import FiltersComponent from "../../Components/FiltersComponent";
import {searchFuntion,findArrayIndex} from '../../Utils/CommonFunctions';

const AutomationProgress = (props) => {
	const {isAutomationProgressModelOpen,progressMsg,toggleModel,executeResults} = props;
	const {results} = executeResults;
	// console.log(results);
    return (
		<Modal size="lg" show={isAutomationProgressModelOpen}>
            <Modal.Header>
                <h4 className="modal-title secondary_color pl-2 mb-0"> Progress Results </h4>
            </Modal.Header>

            <Modal.Body>
            	<div className="row">
                    <div className="filter_Body p-0">
						<ol className="lines-feed">
							{
								results && results.length>0 ? 
									results.map((item,ind) => {
										return (
											<li className={item.active === true ? "feed-item feed-item-secondary IsActive" : "feed-item feed-item-secondary IsInActive"} key={ind}>
												<label className="date">Process {ind+1} </label>
												<span className="text-medium">
													<div className="pb-0 p-1">
													{
														Object.keys(item).map(function(key) {
															return (
																<Wrp>[<span> {key}: <code className="pl-1"> {item[key]} </code> </span>],</Wrp>
															)
														})
													}
													</div>	
								                </span>
											</li>
										)
									})
								: null
							}
						</ol>														 
					</div>
            	</div>
            </Modal.Body>

            <Modal.Footer>
            	 
                    <a onClick={toggleModel} className="btn btn-cancel mr-2" data-dismiss="modal"> Close </a> 
                
            </Modal.Footer>
		</Modal>
	);
}

export default AutomationProgress;